import React from 'react';
import DatePicker from 'react-bootstrap-date-picker';

const DAYS = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель',
  'Май', 'Июнь', 'Июль', 'Август',
  'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

export default class DateInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleChange = (e) => {
    let object = e ? e.substr(0, 10) : "";
    this.props.onChange(this.props.objectKey, object);
  }

  render = () => {
    return (
      <DatePicker
        className="date-input"
        value={this.props.object}
        onChange={this.handleChange}
        disabled={this.props.disabled}
        dateFormat="DD.MM.YYYY"
        dayLabels={DAYS}
        monthLabels={MONTHS}
        weekStartsOnMonday={true}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/DateInput.js